import React from 'react';
import propTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { convertStringForUrl } from '../../../Utils';

// Images
import NoImage from '../../../resources/images/no-image.png';

const HomeCategoryItem = ({ category }) => {
    return (
        <Link className='white shadow rounded-m thumbnail large' to={`/category/${category.id}-${convertStringForUrl(category.title)}`}>
            <img className='img-main rounded-s' src={category.picture || NoImage} alt={category.title} />

            <div className='info'>
                <span>{category.title}</span>
            </div>
        </Link>
    );
}

HomeCategoryItem.propTypes = {
    category: propTypes.object.isRequired
};

export default HomeCategoryItem;